import { PDF_STYLES, PDF_CONFIG } from './pdfConstants';

/**
 * إنشاء container مخفي للمحتوى HTML
 */
export const createHtmlContainer = (htmlContent: string): HTMLDivElement => {
  console.log('🔄 إنشاء HTML Container...');
  
  const containerDiv = document.createElement('div');
  containerDiv.style.position = 'fixed';
  containerDiv.style.left = '-9999px';
  containerDiv.style.top = '-9999px';
  containerDiv.style.width = '210mm';
  containerDiv.style.height = 'auto';
  containerDiv.style.padding = '5mm 0';
  containerDiv.style.backgroundColor = 'white';
  containerDiv.style.fontFamily = 'Tajawal, Arial, sans-serif';
  containerDiv.style.fontSize = '12px';
  containerDiv.style.direction = 'rtl';
  containerDiv.style.overflow = 'visible';
  containerDiv.style.isolation = 'isolate';
  containerDiv.style.zIndex = '-9999';
  containerDiv.style.contain = 'style layout';
  
  containerDiv.innerHTML = htmlContent;
  
  // إضافة الأنماط المضمنة مع عزل كامل
  const styleElement = document.createElement('style');
  styleElement.textContent = PDF_STYLES;
  styleElement.setAttribute('data-pdf-styles', 'true');
  containerDiv.className = 'pdf-container';
  containerDiv.appendChild(styleElement);
  
  document.body.appendChild(containerDiv);
  return containerDiv;
};

/**
 * انتظار تحميل المحتوى والصور
 */
export const waitForContentLoad = async (): Promise<void> => {
  console.log('⏳ انتظار تحميل المحتوى والصور...');
  await new Promise(resolve => setTimeout(resolve, PDF_CONFIG.WAIT_TIME));
};

/**
 * التحقق من صحة المحتوى
 */
export const validateContent = (containerDiv: HTMLDivElement): void => {
  if (!containerDiv || containerDiv.children.length === 0) {
    throw new Error('فشل في تحميل محتوى PDF - المحتوى فارغ');
  }
};

/**
 * تنظيف الـ container
 */
export const cleanupContainer = (containerDiv: HTMLDivElement): void => {
  try {
    if (containerDiv && containerDiv.parentNode) {
      // إزالة أي أنماط PDF محقونة
      const pdfStyles = document.querySelectorAll('style[data-pdf-styles="true"]');
      pdfStyles.forEach(style => {
        if (style.parentNode && style.parentNode !== containerDiv) {
          style.parentNode.removeChild(style);
        }
      });
      
      document.body.removeChild(containerDiv);
      console.log('✅ تم تنظيف PDF container بنجاح');
    }
  } catch (error) {
    console.warn('تحذير: فشل في إزالة الـ container:', error);
  }
};

/**
 * تنظيف الـ containers في حالة الخطأ
 */
export const cleanupOnError = (): void => {
  try {
    // تنظيف أي containers متبقية
    const existingContainers = document.querySelectorAll('.pdf-container');
    existingContainers.forEach(container => {
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    });
    
    // تنظيف أي أنماط PDF محقونة
    const pdfStyles = document.querySelectorAll('style[data-pdf-styles="true"]');
    pdfStyles.forEach(style => {
      if (style.parentNode) {
        style.parentNode.removeChild(style);
      }
    });
    
    console.log('✅ تم تنظيف جميع عناصر PDF');
  } catch (error) {
    console.warn('تحذير: فشل في تنظيف الـ containers:', error);
  }
};